import React from "react";
import { useForm} from "react-hook-form";
import { useState } from "react";
import { toast } from "react-toastify";
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const BASE_URL = process.env.REACT_APP_BASE_URL;
const ProjectForm = ({ onClose, onSave, project, fetchProjects }) => {
    const [loading, setLoading] = useState(false);
  
  const { register, handleSubmit, control, watch, setValue, getValues, reset } =
    useForm({
      defaultValues: {
        name: "",
        description: "",
        skills: [],
        newSkill: "",
        media: null,
        currentlyWorking: false,
        startMonth: "",
        startYear: "",
        endMonth: "",
        endYear: "",
      },
    });

  React.useEffect(() => {
    if (project && Object.keys(project).length > 0) {
      reset({
        name: project.project_name || "",
        description: project.description || "",
        skills: project.skills || [],
        newSkill: "",
        media: project.media || null,
        currentlyWorking: project.is_current || false,
        startMonth: project.start_month || "",
        startYear: project.start_year || "",
        endMonth: project.end_month || "",
        endYear: project.end_year || "",
      });
    } else {
      reset();
    }
  }, [project]);
  const currentlyWorking = watch("currentlyWorking");
  const skills = watch("skills");
  const newSkill = watch("newSkill");

  const addSkill = () => {
    const regex = /^[a-zA-Z0-9\s.+#-]+$/;
        if(!newSkill.trim())
        {
          toast.error('Please skill required or not empty')
          return;
        }
         if (!regex.test(newSkill)) {
  toast.error('Enter Valid Skill');
  return;
}
    if (newSkill.trim()) {
      setValue("skills", [...skills, newSkill.trim()]);
      setValue("newSkill", "");
    }
  };
  

  const onSubmit = async (data) => {
  const token =
  localStorage.getItem("access_token") || localStorage.getItem("access");
  const formPayload = new FormData();
  formPayload.append("project_name", data.name);
  formPayload.append("description", data.description || "");
  formPayload.append("is_current", data.currentlyWorking);
  formPayload.append("start_month", data.startMonth || "");
  formPayload.append("start_year", data.startYear || "");

  if (!data.currentlyWorking) {
    formPayload.append("end_month", data.endMonth || "");
    formPayload.append("end_year", data.endYear || "");
  }

  if (data.media && data.media instanceof File) {
    formPayload.append("media", data.media);
  }

  data.skills.forEach((skill) => {
    formPayload.append("skills", skill);
  });

  try {
    setLoading(true);
    let response;
    if (project?.id) {
      formPayload.append("id", project.id);
      response = await fetch(`${BASE_URL}/user/portfolio/projects/`, {
        method: "PATCH",
        headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },
        body: formPayload,
      });
    } else {
      response = await fetch(`${BASE_URL}/user/portfolio/projects/`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },
        body: formPayload,
      });
    }

    if (!response.ok) {
      const errData = await response.json();
      console.error("API Error:", errData);
      throw new Error("Failed to submit project");
    }

    const result = await response.json();
    console.log("Project saved:", result);

    onSave(result.data); 
    reset();
    onClose();
  } catch (error) {
    console.error("Error submitting project:", error);
    toast.error("Failed to submit project");
  } finally {
    setLoading(false);
  }
};

  return (
<div className="w-full px-0 md:px-6">
  <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
    {/* Project Name */}
    <div>
      <div className="w-full flex items-center gap-2 mb-3">
        <label className="text-sm font-semibold text-gray-700">
          Project name <span className="text-red-500">*</span>
        </label>
      </div>
      <input
        type="text"
        {...register("name", { required: true })}
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>

    {/* Description */}
    <div>
      <div className="flex items-center gap-2 mb-3">
        <label className="text-sm font-semibold text-gray-700">
          Description
        </label>
      </div>
      <textarea
        rows={3}
        placeholder="Add a brief description..."
        {...register("description")}
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 resize-none transition-all"
      />
    </div>

    {/* Skills */}
    <div>
      <div className="flex items-center gap-2 mb-3">
        <label className="text-sm font-semibold text-gray-700">
          Skills
        </label>
      </div>

      <div className="flex gap-2">
        <input
          type="text"
          {...register("newSkill")}
          placeholder="Add a skill"
          className="flex-1 px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
        />
        <button
          type="button"
          onClick={addSkill}
          className="w-12 h-12 bg-gray-100 border border-gray-300 rounded-xl flex items-center justify-center hover:bg-gray-200 transition-colors"
        >
          <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
          </svg>
        </button>
      </div>

      {/* Skills List */}
      <div className="flex flex-wrap gap-2 mt-3">
        {skills.map((skill, idx) => (
          <span
            key={idx}
            className="inline-flex items-center gap-2 bg-[#e8f0f7] text-[#0f6abf] rounded-lg px-3 py-1.5 text-sm font-medium"
          >
            {skill}
            <button
              type="button"
              onClick={() =>
                setValue(
                  "skills",
                  skills.filter((_, i) => i !== idx)
                )
              }
              className="text-[#0f6abf] hover:text-red-500 transition-colors"
            >
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </span>
        ))}
      </div>
    </div>

    {/* Media */}
    <div>
      <div className="flex items-center gap-2 mb-3">
        <label className="text-sm font-semibold text-gray-700">
          Media
        </label>
      </div>

      {project?.media && typeof project.media === "string" && (
        <div className="mb-3 p-3 bg-gray-50 rounded-xl">
          <a
            href={project.media}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0f6abf] hover:underline text-sm font-medium"
          >
            View Uploaded Media
          </a>
          <p className="text-xs text-gray-500 mt-1">
            Uploading a new file will replace the existing one.
          </p>
        </div>
      )}

      <div className="border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-[#0f6abf] transition-colors">
        <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center mx-auto mb-3">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
        <input
          type="file"
          onChange={(e) => setValue("media", e.target.files[0])}
          className="hidden"
          id="media-upload"
        />
        <label
          htmlFor="media-upload"
          className="text-sm font-medium text-gray-700 cursor-pointer hover:text-[#0f6abf] transition-colors"
        >
          Click to upload media
        </label>
        <p className="text-xs text-gray-500 mt-1">JPG, PNG, PDF up to 10MB</p>
      </div>

      {getValues("media") instanceof File && (
        <div className="mt-3 p-3 bg-green-50 text-green-700 rounded-xl text-sm">
          Selected: {getValues("media")?.name}
        </div>
      )}
    </div>

    {/* Currently Working */}
    <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl">
      <input
        type="checkbox"
        id="currentlyWorking"
        {...register("currentlyWorking")}
        className="w-5 h-5 border-2 border-gray-300 rounded checked:bg-[#0f6abf] checked:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20"
      />
      <label htmlFor="currentlyWorking" className="text-sm text-gray-700 cursor-pointer">
        I am currently working on this project
      </label>
    </div>

    {/* Start Date */}
    <div>
      <div className="flex items-center gap-2 mb-3">
        <label className="text-sm font-semibold text-gray-700">
          Start Date
        </label>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <select
          {...register("startMonth")}
          className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
        >
          <option value="">Month</option>
          {months.map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>

        <input
          type="number"
          placeholder="Year"
          {...register("startYear")}
          className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
        />
      </div>
    </div>

    {/* End Date */}
    {!currentlyWorking && (
      <div>
        <div className="flex items-center gap-2 mb-3">
          <label className="text-sm font-semibold text-gray-700">
            End Date
          </label>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <select
            {...register("endMonth")}
            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          >
            <option value="">Month</option>
            {months.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>

          <input
            type="number"
            placeholder="Year"
            {...register("endYear")}
            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          />
        </div>
      </div>
    )}

    {/* Actions */}
    <div className="pt-6 border-t border-gray-200">
      <button
        type="submit"
        disabled={loading}
        className="w-full py-3 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
      >
        {loading ? (
          <>
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            Saving...
          </>
        ) : (
          <>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            Save Project
          </>
        )}
      </button>
    </div>
  </form>
</div>
  );
};

export default ProjectForm;
